import type { Tone } from "@nymbl/nos2-rules";
import type { ApprovalStatus, PaymentStatus } from "@/lib/expenses/rules";

export const APPROVAL_TONES: Record<ApprovalStatus, Tone> = {
  draft: "neutral",
  pending: "warning",
  approved: "success",
  rejected: "danger",
  escalated: "warning",
};

export const PAYMENT_TONES: Record<PaymentStatus, Tone> = {
  notapproved: "neutral",
  pendingpayment: "info",
  paid: "success",
  late: "danger",
};
